import { render, staticRenderFns } from "./role_tree_table.vue?vue&type=template&id=36dfbe54&scoped=true"
import script from "./role_tree_table.vue?vue&type=script&lang=js"
export * from "./role_tree_table.vue?vue&type=script&lang=js"
import style0 from "./role_tree_table.vue?vue&type=style&index=0&id=36dfbe54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36dfbe54",
  null
  
)

export default component.exports